import { FieldArray } from 'formik'
import { observer } from 'mobx-react-lite'
import React, { Fragment } from 'react'
import { Trash } from 'react-bootstrap-icons'
import ReportSection from '../../../../../../models/ReportSection'
import Input from '../../../../../FormComponents/Input'
import Textarea from '../../../../../FormComponents/Textarea'
import { useReadOnly } from '../../../../../../contexts/ReadOnlyContext'

export default observer(function Sections({ values, handleBlur, handleChange, setFieldValue }) {
  const readOnly = useReadOnly()

  return (
    <div className="mt-8 mb-4">
      <FieldArray name="custom_campaign_overview_sections_attributes">
        {({ insert, remove, push }) => (
          <Fragment>
            <div>
              { values.custom_campaign_overview_sections_attributes.map((section, index) =>
                <div key={index}>
                  {!section._destroy &&
                    <Fragment>
                      <div className="flex justify-between">
                        <p className="font-bold dark:text-white">Section {index + 1}</p>
                        {!readOnly && <button className="dark:text-white" onClick={() => setFieldValue(`custom_campaign_overview_sections_attributes.${index}._destroy`, true, true)}><Trash /></button>}
                      </div>

                      <Input
                        label="Title"
                        placeholder="Write something here"
                        name={`custom_campaign_overview_sections_attributes.${index}.title`}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        value={values.custom_campaign_overview_sections_attributes[index]?.title}
                      />

                      <Textarea
                        className={'rounded-lg px-4 w-full'}
                        rows={4}
                        label="Free text"
                        placeholder="Write something here"
                        name={`custom_campaign_overview_sections_attributes.${index}.free_text`}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        value={values.custom_campaign_overview_sections_attributes[index]?.free_text}
                      />
                    </Fragment>
                  }
                </div>
              )}
            </div>
            {!readOnly && (
              <div className="flex justify-end">
                <button className="bg-rb-green dark:bg-rb-green text-white dark:text-white py-2 px-3 rounded-md text-sm font-bold" type='button' onClick={() => push(new ReportSection)}>Add new section</button>
              </div>
            )}
          </Fragment>
        )}
      </FieldArray>
    </div>
  )
})